import { FundStatus, OfferingTransaction, SignedStatus, TransactionStatus } from '@arrived/models';

export const isTradeNeedsFunding = (transaction: OfferingTransaction): boolean =>
  transaction.status === TransactionStatus.CREATED &&
  transaction.documentsSignedStatus === SignedStatus.SIGNED &&
  (transaction.fundStatus === FundStatus.DECLINED ||
    transaction.fundStatus === FundStatus.RETURNED ||
    transaction.fundStatus === FundStatus.VOIDED);
